var _path, _path2, _g, _path3, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPhotoMomentIcon(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 1000 1000",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#Photo_Moment_icon_svg__clip0_2002_337)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M767.607 161.75H232.405v676.5h535.202v-676.5z",
    fill: "#fff",
    stroke: "#93D5DE",
    strokeWidth: 16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "Photo_Moment_icon_svg__a",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 291,
    y: 221,
    width: 418,
    height: 424
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M708.083 644.5V221.274H291.929V644.5h416.154z",
    fill: "#fff"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#Photo_Moment_icon_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M708.083 644.5V221.274H291.929V644.5h416.154z",
    fill: "#A446C6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.524 619.084c14.428-13.655 25.869-30.941 32.738-51.155 21.726-63.941-11.31-134.369-74.345-158.595-65.929-25.334-139.643 8.178-164.012 74.238-6.953 18.857-9.119 38.297-7.131 57.012l212.75 78.5z",
    fill: "#F93444",
    stroke: "#F93444",
    strokeWidth: 16,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.155 474.346c-12.107 0-24.036-2.143-35.488-6.37-53.048-19.571-80.274-78.654-60.703-131.702 14.798-40.119 53.465-67.071 96.215-67.071 12.107 0 24.035 2.142 35.488 6.369 53.047 19.571 80.273 78.654 60.702 131.702-14.798 40.119-53.464 67.072-96.214 67.072z",
    fill: "#40A9D6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.179 278.726c10.69 0 21.571 1.857 32.19 5.774 48.202 17.786 72.845 71.274 55.071 119.464-13.869 37.572-49.44 60.846-87.273 60.846-10.691 0-21.572-1.857-32.191-5.774-48.202-17.786-72.857-71.274-55.071-119.464 13.869-37.572 49.44-60.846 87.274-60.846zm0-19.047c-22.691 0-44.608 6.797-63.393 19.666-19.226 13.167-33.667 31.715-41.762 53.631-10.357 28.084-9.167 58.524 3.357 85.703 12.524 27.178 34.893 47.869 62.976 58.226a111.593 111.593 0 0038.786 6.952c22.69 0 44.607-6.797 63.393-19.666 19.226-13.167 33.666-31.715 41.762-53.631 10.357-28.084 9.166-58.524-3.358-85.703-12.535-27.19-34.892-47.869-62.976-58.226a111.588 111.588 0 00-38.785-6.952z",
    fill: "#4084D6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.155 392.595c2.143 10.226 9.321 19.167 19.821 23.036 10.5 3.869 21.774 1.738 30.036-4.643",
    fill: "#40A9D6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.155 392.595c2.143 10.226 9.321 19.167 19.821 23.036 10.5 3.869 21.774 1.738 30.036-4.643",
    stroke: "#4084D6",
    strokeWidth: 16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.976 363.048a6.643 6.643 0 100-13.286 6.643 6.643 0 000 13.286zM438.071 383.751a6.643 6.643 0 100-13.287 6.643 6.643 0 000 13.287z",
    fill: "#40A9D6",
    stroke: "#4084D6",
    strokeWidth: 16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M492.952 586.286c-3.821 21.119-2.488 43.5 4.941 65.357 7.547 22.226 20.631 41.143 37.214 55.738l213.798-66.5c5.571-22.428 5.274-46.631-2.095-70.309-6.477-20.81-17.667-38.834-32.024-53.298l12.845-154.298c1.345-16.154-10.667-30.345-26.821-31.69-16.155-1.345-30.346 10.667-31.691 26.821l-10.464 125.727c-23.929-7.048-50.119-7.346-75.726.619-25.608 7.964-47.012 23.071-62.715 42.44l-79.94-97.607c-10.274-12.548-28.774-14.381-41.31-4.107-12.547 10.274-14.381 28.774-4.107 41.309l98.107 119.786-.012.012z",
    fill: "#FA99A1",
    stroke: "#FA6975",
    strokeWidth: 16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M664.238 416.786l-5.583 67.048c-23.929-7.048-50.119-7.346-75.726.619-25.608 7.964-47.012 23.071-62.715 42.44l-38.904-47.512c-13.358 16.024-24.072 34.322-31.477 54.226l43.131 52.655c-3.821 21.119-2.488 43.5 4.941 65.357 7.547 22.227 20.631 41.143 37.214 55.738l213.798-66.5c5.571-22.428 5.273-46.63-2.096-70.309-6.476-20.81-17.666-38.833-32.023-53.298l6.452-77.512a184.584 184.584 0 00-57-22.976l-.012.024z",
    fill: "#4084D6",
    stroke: "#4084D6",
    strokeWidth: 16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M571.464 548.905c55.945 0 101.298-45.353 101.298-101.298S627.409 346.31 571.464 346.31s-101.297 45.352-101.297 101.297 45.352 101.298 101.297 101.298z",
    fill: "#FA99A1",
    stroke: "#FA6975",
    strokeWidth: 16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M555.036 487.417c8.202 7.047 19.75 9.857 30.809 6.404 11.072-3.44 18.976-12.297 21.738-22.761",
    fill: "#FA99A1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M555.036 487.417c8.202 7.047 19.75 9.857 30.809 6.404 11.072-3.44 18.976-12.297 21.738-22.761",
    stroke: "#FA6975",
    strokeWidth: 16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M540.262 458.393a6.88 6.88 0 100-13.761 6.88 6.88 0 000 13.761zM599.381 440a6.881 6.881 0 100-13.763 6.881 6.881 0 000 13.763z",
    fill: "#FA99A1",
    stroke: "#FA6975",
    strokeWidth: 16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.548 707.441c61.645 0 111.619-49.974 111.619-111.619 0-61.646-49.974-111.619-111.619-111.619-61.646 0-111.619 49.973-111.619 111.619 0 61.645 49.973 111.619 111.619 111.619z",
    fill: "#FED425",
    stroke: "#FD934F",
    strokeWidth: 16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.726 613.131c.453 12.524 7.131 24.56 18.774 31.274 11.631 6.714 25.393 6.488 36.464.619",
    fill: "#FED425"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.726 613.131c.453 12.524 7.131 24.56 18.774 31.274 11.631 6.714 25.393 6.488 36.464.619",
    stroke: "#FD934F",
    strokeWidth: 16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.69 580.298a7.976 7.976 0 10-7.976-7.976 7.976 7.976 0 007.976 7.976zM406.833 616.179a7.977 7.977 0 100-15.954 7.977 7.977 0 000 15.954z",
    fill: "#FED425",
    stroke: "#FD934F",
    strokeWidth: 16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M708.083 644.5V221.274H291.929V644.5h416.154z",
    stroke: "#93D5DE",
    strokeWidth: 16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "Photo_Moment_icon_svg__clip0_2002_337"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h1000v1000H0z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhotoMomentIcon);
export default ForwardRef;